import { Info, ListAlt, Hotel, Groups, Flight, LocationOn, Assignment, Group, Store, ConfirmationNumber } from '@mui/icons-material';
import { getEventGroup } from './common';

// The sections of an event page, in the order they appear everywhere:
// the mobile bottom bar (first four) and its More menu, the desktop tabs and the sidebar under the open event.
export const EVENT_SECTIONS = [
    { label: 'Info', path: '', Icon: Info },
    { label: 'Itinerary', path: '/itinerary', Icon: ListAlt },
    { label: 'Hotel', path: '/hotels', Icon: Hotel },
    { label: 'Crew', path: '/crew', Icon: Groups },
    { label: 'Travel', path: '/travel', Icon: Flight },
    { label: 'Map', path: '/map', Icon: LocationOn },
    { label: 'Tech Rider', path: '/advancing', Icon: Assignment },
    { label: 'Guest List', path: '/guestlist', Icon: Group, concertOnly: true },
    { label: 'Merch', path: '/merch', Icon: Store, concertOnly: true },
    { label: 'Finance', path: '/tickets', Icon: ConfirmationNumber, concertOnly: true },
];

// Guest List, Merch and Finance only apply to live events (concerts, festivals, ...)
export const getEventSections = (eventType) => {
    const isLive = getEventGroup(eventType) === 'LIVE';
    return EVENT_SECTIONS.filter((section) => isLive || !section.concertOnly);
};

// The section a URL under /event/:eventId points at (Info for the event root and anything unknown)
export const getEventSectionLabel = (pathname) =>
    EVENT_SECTIONS.find((section) => section.path && pathname.endsWith(section.path))?.label || 'Info';
